
import { mapGetters, mapActions, mapMutations } from 'vuex';
import searchRouter from '@/plugins/searchRouter.client';
import {
  CLICK_BEST_KEYWORD,
  CLICK_RECOMMEND_KEYWORD,
} from '@/utils/amplitudeEvent/amplitudeEvents.js';

export default {
  name: 'KeywordSection',
  mixins: [searchRouter],
  fetchOnServer: false,
  async fetch() {
    if (this.bestKeywordList.length <= 0) await this.selectBestKeywordList();
    if (this.recommendedKeywordList <= 0)
      await this.selectRecommendKeywordList();
  },
  computed: {
    ...mapGetters('product/search', [
      'recommendedKeywordList',
      'bestKeywordList',
    ]),
    ...mapGetters('filter/category', ['categoryOptions']),
    ...mapGetters('filter', ['categoryDifficultyMap']),
  },
  methods: {
    ...mapActions('product/search', [
      'selectBestKeywordList',
      'selectRecommendKeywordList',
    ]),
    ...mapActions('filter', ['getCategoryDifficultyList']),
    ...mapMutations({ setKeyword: 'filter/keyword/CHANGE_KEYWORD' }),
    ...mapMutations('search/filter', ['SET_KEYWORD']),
    goToTop() {
      window.scroll({ top: 0 });
    },
    onSearchBestKeyword(keyword, rank) {
      this.logUserCustomEvent(CLICK_BEST_KEYWORD, {
        keyword,
        rank: rank >= 0 ? rank + 1 : '',
      });
      this.onSearch(keyword, 'best');
    },
    onSearchRecommendKeyword(keyword, rank) {
      this.logUserCustomEvent(CLICK_RECOMMEND_KEYWORD, {
        keyword,
        rank: rank >= 0 ? rank + 1 : '',
      });
      this.onSearch(keyword, 'recommend');
    },
    onSearch(keyword, from) {
      if (this.$route.query.order) {
        this.goToTop();
      }
      this.SET_KEYWORD(keyword);
      this.onPopularSearchClick(keyword, from);
    },
    onClickCategory(selectedCategory) {
      this.onPopularSearchCategoryClick(selectedCategory);
      if (
        selectedCategory &&
        this.categoryDifficultyMap[selectedCategory] === undefined
      ) {
        this.getCategoryDifficultyList(selectedCategory);
      }
    },
  },
};
